/* eslint-disable @typescript-eslint/ban-ts-ignore */

export const locales = {
  ar: {
    chooseLang: 'الرجاء اختيار لغتك',
    selectOneLanguage: 'حدد إحدى اللغات المتاحة من القائمة أدناه',
  },
  bg: {
    chooseLang: 'Моля, изберете вашия език.',
    selectOneLanguage: 'Изберете един от наличните езици от списъка по-долу',
  },
  cs: {
    chooseLang: 'Vyberte prosím svůj jazyk.',
    selectOneLanguage: 'V seznamu níže vyberte jeden z dostupných jazyků.',
  },
  da: {
    chooseLang: 'Vælg dit sprog.',
    selectOneLanguage: 'Vælg et af de tilgængelige sprog på listen nedenfor.',
  },
  de: {
    chooseLang: 'Bitte wählen Sie eine Sprache.',
    selectOneLanguage:
      'Wählen Sie eine der verfügbaren Sprachen aus der Liste unten.',
  },
  nl: {
    chooseLang: 'Kies een taal.',
    selectOneLanguage:
      'Selecteer een van de beschikbare talen uit de onderstaande lijst.',
  },
  el: {
    chooseLang: 'Επιλέξτε τη γλώσσα σας.',
    selectOneLanguage:
      'Επιλέξτε μία από τις διαθέσιμες γλώσσες από την παρακάτω λίστα.',
  },
  en: {
    chooseLang: 'Please choose your language.',
    selectOneLanguage:
      'Select one of the available languages from the list below.',
  },
  es: {
    chooseLang: 'Elija su idioma.',
    selectOneLanguage:
      'Seleccione uno de los idiomas disponibles de la lista a continuación.',
  },
  fi: {
    chooseLang: 'Valitse kieli.',
    selectOneLanguage:
      'Valitse jokin käytettävissä olevista kielistä alla olevasta luettelosta.',
  },
  fr: {
    chooseLang: 'Veuillez sélectionner une langue.',
    selectOneLanguage:
      'Sélectionnez une des langues disponsibles dans la liste ci-dessous.',
  },
  he: {
    chooseLang: 'אנא בחר את השפה שלך.',
    selectOneLanguage: 'בחר אחת מהשפות הזמינות מהרשימה שלמטה',
  },
  hr: {
    chooseLang: 'Odaberite svoj jezik.',
    selectOneLanguage:
      'S popisa u nastavku odaberite jedan od dostupnih jezika.',
  },
  hu: {
    chooseLang: 'Válasszon nyelvet.',
    selectOneLanguage:
      'Válassza ki az elérhető nyelvek egyikét az alábbi listából.',
  },
  is: {
    chooseLang: 'Vinsamlegast veldu tungumál.',
    selectOneLanguage:
      'Veldu eitt af tiltækum tungumálum af listanum hér að neðan.',
  },
  it: {
    chooseLang: 'Si prega di selezionare una lingua. ',
    selectOneLanguage:
      "Selezionare una delle lingue disponibili dall'elenco sottostante.",
  },
  sv: {
    chooseLang: 'Välj ett språk.',
    selectOneLanguage: 'Välj ett av de tillgängliga språken från listan nedan.',
  },
  no: {
    chooseLang: 'Velg språk.',
    selectOneLanguage:
      'Velg et av de tilgjengelige språkene fra listen nedenfor.',
  },
  pl: {
    chooseLang: 'Proszę wybrać język.',
    selectOneLanguage: 'Wybierz jeden z dostępnych języków z poniższej listy.',
  },
  pt: {
    chooseLang: 'Escolha um idioma.',
    selectOneLanguage: 'Selecione um dos idiomas disponíveis na lista abaixo.',
  },
  ja: {
    chooseLang: '言語を選択してください。',
    selectOneLanguage:
      '以下のリストから利用可能な言語の1つを選択してください。',
  },
  sk: {
    chooseLang: 'Vyberte jazyk.',
    selectOneLanguage: 'V zozname nižšie vyberte jeden z dostupných jazykov.',
  },
  sl: {
    chooseLang: 'Izberite jezik.',
    selectOneLanguage:
      'Na spodnjem seznamu izberite enega od razpoložljivih jezikov.',
  },
  lb: {
    chooseLang: 'Wielt w.e.g. eng Sprooch.',
    selectOneLanguage:
      'Wielt eng vun de verfügbare Sproochen aus der Lëscht hei drënner.',
  },
  ro: {
    chooseLang: 'Vă rugăm să alegeți o limbă.',
    selectOneLanguage:
      'Selectați una dintre limbile disponibile din lista de mai jos',
  },
  th: {
    chooseLang: 'โปรดเลือกภาษา',
    selectOneLanguage: 'เลือกภาษาที่มีอยู่จากรายการด้านล่าง',
  },
  tr: {
    chooseLang: 'Lütfen bir dil seçin.',
    selectOneLanguage: 'Aşağıdaki listeden mevcut dillerden birini seçin.',
  },
  uk: {
    chooseLang: 'Виберіть мову.',
    selectOneLanguage: 'Виберіть одну з доступних мов зі списку нижче.',
  },
  vi: {
    chooseLang: 'Vui lòng chọn một ngôn ngữ.',
    selectOneLanguage:
      'Chọn một trong các ngôn ngữ có sẵn từ danh sách bên dưới.',
  },
  ru: {
    chooseLang: 'Пожалуйста, выберите язык.',
    selectOneLanguage: 'Выберите один из доступных языков из списка ниже.',
  },
};

export const getTranslationForLanguageSelection = (surveyLangs: string[]) => {
  const translations: {
    title: string[];
    description: string[];
  } = {
    title: [],
    description: [],
  };

  surveyLangs.forEach((locale: string) => {
    // @ts-ignore
    const translatedLocale = locales[locale];

    if (translatedLocale) {
      translations.title.push(`${translatedLocale.chooseLang} <br/>`);
      translations.description.push(
        `${translatedLocale.selectOneLanguage} <br/>`
      );
    }
  });

  return translations;
};
